import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import FindUs from "./sections/FindUs";
import CommonCuriosities from "./sections/CommonCuriosities";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <GetInTouch />
      <FindUs />
      <CommonCuriosities />
      <Footer />
    </div>;
}